import { useEffect, useState } from "react";
import api from "@/lib/api";

// A separate tab preserves the unsaved job form. Reports and profiles are
// persisted by the scanner; returning here never changes form selections.
export function SourceScannerLink({ source, account, jobId }) {
  const [report, setReport] = useState(null);
  useEffect(() => {
    let stopped = false;
    setReport(null);
    const load = async () => {
      if (!source || !account) return;
      try {
        const { data } = await api.get("/channel-scanner/scans");
        if (!stopped) setReport(data.find((s) => s.status === "completed" && s.account_id === account && String(s.source).toLowerCase() === String(source).toLowerCase()) || null);
      } catch { /* Scanner availability must not block the Copy Job form. */ }
    };
    const changed = (event) => { if (event.key === "clonecast-scanner-result") load(); };
    load();
    window.addEventListener("focus", load);
    window.addEventListener("storage", changed);
    return () => { stopped = true; window.removeEventListener("focus", load); window.removeEventListener("storage", changed); };
  }, [source, account]);
  if (!source) return null;
  const query = new URLSearchParams({ source, account: account || "", job: jobId || "" });
  return <div className="text-xs space-y-1">
    <a className="block text-[var(--c-sky)] hover:underline" target="_blank" rel="noopener noreferrer" href={`/channel-scanner?${query}`}>Analyze source branding ↗</a>
    {report && <div className="text-[var(--tg-muted)]">{report.messages_scanned.toLocaleString()} messages analysed · {report.findings_count} findings · <a className="text-[var(--c-sky)] hover:underline" target="_blank" rel="noopener noreferrer" href={`/channel-scanner?${query}&scan=${encodeURIComponent(report.id)}`}>Review findings ↗</a></div>}
  </div>;
}
